import React, { useState } from 'react';
import { User } from '@/types';
import {
  IoPerson,
  IoOptions,
  IoShield,
  IoCard,
  IoNotifications,
  IoLockClosed,
  IoSearch,
  IoSaveOutline
} from 'react-icons/io5';
import ProfileTab from './components/ProfileTab';
import GeneralTab from './components/GeneralTab';
import './Settings.css';

interface SettingsProps {
  user: User;
}

type TabType = 'profile' | 'general' | 'account' | 'billing' | 'notifications' | 'privacy';

interface Tab {
  id: TabType;
  label: string;
  icon: React.ReactNode;
  disabled?: boolean;
}

const Settings: React.FC<SettingsProps> = ({ user }) => {
  const [activeTab, setActiveTab] = useState<TabType>('profile');
  const [searchQuery, setSearchQuery] = useState('');

  const tabs: Tab[] = [
    { id: 'profile', label: 'Profile', icon: <IoPerson /> },
    { id: 'general', label: 'General', icon: <IoOptions />, disabled: true },
    { id: 'account', label: 'Account', icon: <IoShield />, disabled: true },
    { id: 'billing', label: 'Billing', icon: <IoCard />, disabled: true },
    { id: 'notifications', label: 'Notifications', icon: <IoNotifications />, disabled: true },
    { id: 'privacy', label: 'Privacy', icon: <IoLockClosed />, disabled: true },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'profile':
        return <ProfileTab user={user} />;
      case 'general':
        return <GeneralTab />;
      case 'account':
        return <div className="settings-tab-content">Account settings coming soon...</div>;
      case 'billing':
        return <div className="settings-tab-content">Billing settings coming soon...</div>;
      case 'notifications':
        return <div className="settings-tab-content">Notification settings coming soon...</div>;
      case 'privacy':
        return <div className="settings-tab-content">Privacy settings coming soon...</div>;
      default:
        return null;
    }
  };

  return (
    <div className="settings-page">
      <div className="settings-container">
        <div className="settings-header">
          <h1 className="settings-title">Settings</h1>
          <div className="settings-search">
            <IoSearch className="settings-search-icon" />
            <input
              type="text"
              placeholder="Search settings..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="settings-search-input"
            />
          </div>
          <button className="settings-save-button">
            <IoSaveOutline />
            Save Changes
          </button>
        </div>

        <div className="settings-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`settings-tab ${activeTab === tab.id ? 'active' : ''} ${tab.disabled ? 'disabled' : ''}`}
              disabled={tab.disabled}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </div>

        <div className="settings-content">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};

export default Settings;
